import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { volunteersApi } from "@/api";
import { QueryKey } from "@/query/Query";
import { VolunteerByIdParams } from "@/router/SystemSettingsRoutes";

export function useVolunteer() {
  const { id } = useParams<VolunteerByIdParams>();

  const { data: volunteer, isLoading } = useQuery({
    queryKey: [QueryKey.Volunteers, id],
    queryFn: () => volunteersApi.getVolunteerById({ id: id ?? "" }),
    enabled: !!id,
    meta: { loadingScope: "pageContent" },
  });

  return { volunteer, isLoading };
}
